//#region src/utils/shortId.ts
const alphabet = "abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ0123456789";
function genShortID(length = 10) {
	const values = new Uint32Array(length);
	const cryptoObj = typeof globalThis !== "undefined" ? globalThis.crypto : void 0;
	if (cryptoObj === null || cryptoObj === void 0 ? void 0 : cryptoObj.getRandomValues) cryptoObj.getRandomValues(values);
	else for (let i = 0; i < length; i++) values[i] = Math.floor(Math.random() * 4294967296);
	let result = "";
	for (let i = 0; i < length; i++) result += alphabet[values[i] % 59];
	return result;
}
//#endregion
export { genShortID };

//# sourceMappingURL=shortId.js.map